import { ShiftChangeStatusInterface } from '../../../interfaces/shift-change-status.interface';

export class ClearAwaitingShiftStatus {
    public static readonly type = '[JobsPlacements] Clear shift awaiting status';

    constructor(public data: ShiftChangeStatusInterface) {}
}
